import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BodyTextWrapper, InlineBodyTextWrapper } from "./BodyText.styles";
var BodyText = function(param) {
    var children = param.children, className = param.className, _inline = param.inline, inline = _inline === void 0 ? false : _inline, textColor = param.textColor;
    var Wrapper = inline ? InlineBodyTextWrapper : BodyTextWrapper;
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: className,
        textColor: textColor,
        children: children
    });
};
export { BodyText };
